export default __webpack_public_path__ + "static/media/logoPequenoBranco.d2169418.svg";